const baseUrl = process.env.REACT_APP_SERVER_URL

export const getBaseUrl = () => {
    return baseUrl
}